import React, { useCallback, useEffect, useRef, useState } from "react";
import { OfferTrackingTableHeaderData } from "./OfferTrackingTableHeaderData";
import {
  BasicTable,
  CustomPagination,
  CustomTableHeader,
  NoDataFound,
  TableSkeleton,
} from "../../../../../../Components";
import { useQuery, useSelectedTheme } from "../../../../../../Hooks";
import { GetFilteredVendorClientTrackingsAPI } from "../../../../../../Services";
import { useVerticalNav } from "../../../../../../Contexts/VerticalNavContext";

// styles
import useStyle from "./styles";

function OfferTracking() {
  const styles = useStyle();
  const query = useQuery();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { setAlertBoxContent } = useVerticalNav();
  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 25,
    contactId: query.get("id"),
  });
  const [inputValue, setInputValue] = useState(pagination.pageIndex);
  const firstFetchEmpty = useRef(true);
  const [data, setData] = useState({ result: [], totalCount: 0 });
  const [isLoading, setIsLoading] = useState(false);

  const getFilteredVendorClientTrackings = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await GetFilteredVendorClientTrackingsAPI(pagination);
      if (firstFetchEmpty.current && !!response.totalCount) {
        firstFetchEmpty.current = false;
      }
      setData(response);
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: "something_went_wrong",
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    } finally {
      setIsLoading(false);
    }
  }, [pagination]);

  const handleFilterConfirm = (
    params,
    title,
    inputValue,
    selectedValue,
    inputNameValue,
    selectedNameValue
  ) => {
    const field = params?.field || params?.colDef?.field;

    setPagination((prevBody) => ({
      ...prevBody,
      [field]: inputValue,
    }));
  };

  useEffect(() => {
    getFilteredVendorClientTrackings();
  }, [getFilteredVendorClientTrackings]);

  return (
    <>
      {isLoading ? (
        <TableSkeleton />
      ) : data?.result?.length > 0 ? (
        <BasicTable
          rowHeight={84}
          rowsData={
            data?.result.map((offer) => {
              return {
                ...offer,
                id: offer.vendorClientTrackingId,
              };
            }) || []
          }
          columns={OfferTrackingTableHeaderData(styles, palette)?.map(
            (column) => ({
              ...column,
              renderHeader: (params) => (
                <CustomTableHeader
                  params={params}
                  title={column.headerName}
                  isHiddenFilter={
                    column.headerName !== "Vendor name" &&
                    column.headerName !== "Date of interest"
                  }
                  handleFilterConfirm={handleFilterConfirm}
                />
              ),
            })
          )}
        />
      ) : (
        <NoDataFound title={"Offer Tracking"} />
      )}
      <CustomPagination
        totalItems={data?.totalCount}
        itemsPerPage={pagination.pageSize}
        currentPage={pagination.pageIndex}
        inputValue={inputValue}
        setInputValue={setInputValue}
        onPageChange={(page) =>
          setPagination((prev) => ({ ...prev, pageIndex: page }))
        }
        onItemsPerPageChange={(items) =>
          setPagination((prev) => ({ ...prev, pageSize: items }))
        }
        isLoading={isLoading}
      />
    </>
  );
}

export default OfferTracking;
